module.exports = __webpack_public_path__ + "static/engine-modular-framework-for-web-5991596a72aaa20bc0a2f55e2c87c999.mp4";